/**
 * `EDGE-ASKWINDOW` — the client's typed text, held.
 * OWNER: web-frontend-engineer.
 *
 * He opens the ask form while the order is in `placed`, the tailor confirms
 * before he submits, and the server refuses. The page re-renders as
 * `ST-ORDER-NOTASKABLE` naming the new position — and HIS TEXT IS PRESERVED and
 * offered to the contact route. He wrote it in good faith and must not have to
 * write it twice.
 *
 * The store is injected so this is testable without a browser, and so the
 * contract is a function rather than a habit.
 */

export interface TextStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

const PREFIX = 'pt-ask-draft';

export function askDraftKey(orderRef: string): string {
  return `${PREFIX}:${orderRef}`;
}

/** Held from the first keystroke, so a refusal cannot lose it. */
export function holdAskDraft(store: TextStore, orderRef: string, text: string): void {
  store.setItem(askDraftKey(orderRef), text);
}

export function readAskDraft(store: TextStore, orderRef: string): string {
  return store.getItem(askDraftKey(orderRef)) ?? '';
}

/** Cleared only on a RECORDED request — never on a refusal, never on a reload. */
export function releaseAskDraft(store: TextStore, orderRef: string): void {
  store.removeItem(askDraftKey(orderRef));
}

/** The browser store, or a no-op where there is no browser (tests, SSR). */
export function browserStore(): TextStore {
  if (typeof window === 'undefined') {
    return { getItem: () => null, setItem: () => {}, removeItem: () => {} };
  }
  return window.sessionStorage;
}
